const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M10.184 4.175 6.359 8l3.825 3.825L9 13 4 8l5-5 1.184 1.175Z" />
  </svg>
)

export default ArrowIcon
